import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { IJBPActualsAndTargetsCategory } from 'legacy/lut/services/partner360/common/models/jbpActualsAndTargetsCategories'
import { FC, useCallback, useMemo } from 'react'

import { updateFormDataField } from 'cng-common/features/form'
import { FormDropdown } from 'cng-common/features/form/components/formDropdown/FormDropdown'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IBusinessUnitProps {
  className: string
  initialValue?: string
  businessUnits: IJBPActualsAndTargetsCategory[]
  formKey: string
  isDisabled?: boolean
  label?: string
  placeholder?: string
  clearFocusAreaOnChange?: boolean
}

export const BusinessUnit: FC<IBusinessUnitProps> = ({
  initialValue = '',
  businessUnits,
  className,
  formKey,
  isDisabled,
  label,
  placeholder,
  clearFocusAreaOnChange = true,
}) => {
  const dispatch = useAppDispatch()

  const crud = useMemo(() => {
    return new Crud({
      fetcher: new Static(businessUnits),
      keyField: 'Category',
      defaultPaging: {
        page: 0,
        pageSize: businessUnits.length,
      },
    })
  }, [businessUnits])

  const handleChange = useCallback(() => {
    // Legacy editors keep the dependent selection; Goal Settings opts out.
    if (!clearFocusAreaOnChange) return

    dispatch(
      updateFormDataField({
        field: 'focusArea',
        value: '',
        formKey: formKey,
      })
    )
  }, [clearFocusAreaOnChange, dispatch, formKey])

  return (
    <FormDropdown
      isStatic
      isDisabled={isDisabled}
      formKey={formKey}
      field="businessUnit"
      defaultValue={initialValue}
      classes={{ controlClasses: { root: className } }}
      source={crud}
      caption="CategoryTranslation"
      label={label}
      placeholder={placeholder}
      onChange={handleChange}
    />
  )
}

BusinessUnit.displayName = 'BusinessUnit'
